const DISPLAY_BY_KEY: Record<string, string> = {
  decisao: 'Decisão',
  decreto: 'Decreto',
  'decreto-lei': 'Decreto-Lei',
  'decreto lei': 'Decreto-Lei',
  'instrucao normativa': 'Instrução Normativa',
  lei: 'Lei',
  'medida provisoria': 'Medida Provisória',
  norma: 'Norma',
  portaria: 'Portaria',
  resolucao: 'Resolução',
};

export interface LawTypeOption {
  label: string;
  values: string[];
}

function foldLawType(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase('pt-BR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

function withCapitalInitial(value: string): string {
  const text = value.trim();
  if (!text) return text;
  const first = text.charAt(0).toLocaleUpperCase('pt-BR');
  if (first === text.charAt(0) && text.charAt(0) !== text.charAt(0).toLocaleLowerCase('pt-BR')) return text;
  return first + text.slice(1);
}

/** Uma opção visível por tipo. A busca continua com cada grafia que a tabela já tem. */
export function groupLawTypeOptions(raw: string[]): LawTypeOption[] {
  const groups = new Map<string, string[]>();
  raw.forEach((item) => {
    const text = item.trim();
    if (!text) return;
    const key = foldLawType(text);
    const list = groups.get(key) ?? [];
    if (!list.includes(text)) list.push(text);
    groups.set(key, list);
  });
  return Array.from(groups.entries())
    .map(([key, values]) => ({
      label: DISPLAY_BY_KEY[key] ?? withCapitalInitial(values.find((value) => withCapitalInitial(value) === value) || values[0]),
      values,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
}

/** Nomes dos checkboxes marcados, sem repetir a grafia minúscula. */
export function lawTypeSelectionLabels(selected: string[], catalog: string[] = []): string[] {
  const source = catalog.length ? catalog.concat(selected) : selected;
  return groupLawTypeOptions(source)
    .filter((group) => group.values.some((value) => selected.includes(value)))
    .map((group) => group.label);
}
